import React from "react";
import { Col, Row } from "react-bootstrap";
import { isNotEmptyArray } from "src/services/validationService";
import { formatterPeso } from "src/utils/utils";

const BenefiariesAmountValidationComponent = ({ beneficiaries, totalAmountBeneficiaries, importe, selectedExpedientAssociated, expedientesSeleccionados, isValidTotalAmountBeneficiaries }) => {

    return (
        <>
            {(isNotEmptyArray(expedientesSeleccionados) || isNotEmptyArray(selectedExpedientAssociated)) &&
                <Row className='align-right mt-5 border border-1 rounded px-2 pt-4 my-5 mx-2' >
                    <Col className='col-md-8 text-right mx-0 mb-2 py-2'>
                        Importe total de Orden de Pago
                    </Col>
                    <Col className={`col-md-4 text-right border border-1 rounded mx-0 mb-2 py-2 ${isValidTotalAmountBeneficiaries ? 'bg-success-light' : ''} `}>
                        {isNaN(importe) ? '' : formatterPeso.format(importe)}
                    </Col>
                    {beneficiaries !== undefined &&
                        <>
                            <Col className='col-md-8 text-right mx-0 mb-1 py-2'>
                                Importe Total de Beneficiarios
                            </Col>
                            <Col className={`col-md-4 text-right border border-1 rounded mx-0 mb-1 py-2 ${isValidTotalAmountBeneficiaries ? 'bg-success-light' : ''} `}>
                                {formatterPeso.format(totalAmountBeneficiaries)}
                            </Col>
                        </>
                    }
                    {isNotEmptyArray(beneficiaries) && (!isValidTotalAmountBeneficiaries &&
                        <Col className='offset-md-8 md-4 text-right alert alert-danger my-2'>
                             El total de la orden de pago y los beneficiarios debe coincidir
                        </Col>
                    )}
                </Row>
            }
        </>
    )
};

export default BenefiariesAmountValidationComponent;